export default __webpack_public_path__ + "assets/House.2765b532.png";